import { render, staticRenderFns } from "./ProductSwitcher.vue?vue&type=template&id=c8d2531e&"
import script from "./ProductSwitcher.vue?vue&type=script&lang=js&"
export * from "./ProductSwitcher.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports